export default __webpack_public_path__ + "static/media/PY.7f4d1c31.svg";